export default __webpack_public_path__ + "static/media/016-flippers.32fe85ee.png";